export function formatParameterLabel(raw: string): string {
  return raw
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

const HEX_COLOR_RE = /^#[0-9a-f]{6}$/i;
const COLOR_KEY_RE = /\bcolou?r\b/i;

export function isHexColor(value: string): boolean {
  return HEX_COLOR_RE.test(value);
}

interface IsColorParameterArgs {
  value: string;
  key?: string | null;
  previousValue?: string | null;
}

/** Mirrors backend color typing: hex values are colors, and an empty value can
 * stay color-typed when this key denotes color or when the previous value was
 * hex. */
export function isColorParameter({
  value,
  key,
  previousValue,
}: IsColorParameterArgs): boolean {
  if (isHexColor(value)) return true;
  if (value.trim().length > 0) return false;
  if (previousValue && isHexColor(previousValue)) return true;
  return key ? COLOR_KEY_RE.test(key.replace(/_/g, " ")) : false;
}
